'use client';

import type { ArticleSidebarTab } from '../types';

type ArticleSidebarTabListProps = {
  tabs: Array<{ id: ArticleSidebarTab; label: string; trackName: string }>;
  selectedTab: ArticleSidebarTab;
  onTabChange: (tab: ArticleSidebarTab) => void;
  ariaLabel: string;
  'data-testid'?: string;
};

function ArticleSidebarTabList({ tabs, selectedTab, onTabChange, ariaLabel, 'data-testid': dataTestId }: ArticleSidebarTabListProps) {
  return (
    <div className="flex items-center" role="tablist" aria-label={ariaLabel} data-testid={`${dataTestId}-tabs`} data-track-container="Segmentation">
      {tabs.map((tab, index) => {
        const isSelected = selectedTab === tab.id;

        return (
          <div key={tab.id} className="flex items-center">
            {index > 0 && <span className="mx-4 h-4 w-px bg-border" aria-hidden="true" />}
            <button
              type="button"
              role="tab"
              aria-selected={isSelected}
              data-state={isSelected ? 'active' : 'inactive'}
              className="text-base leading-6 text-foreground underline-offset-2 data-[state=active]:font-bold data-[state=active]:underline"
              onClick={() => onTabChange(tab.id)}
              data-testid={`${dataTestId}-tab-${tab.id}`}
              data-track-name={tab.trackName}
            >
              {tab.label}
            </button>
          </div>
        );
      })}
    </div>
  );
}

export { ArticleSidebarTabList, type ArticleSidebarTabListProps };
